import React from 'react';
import { injectIntl } from 'react-intl-next';
import { type Props } from './types';
import messages from '../../ui/project-pages-improvement/messages';

const PagesHeading = ({ intl, isPreExpand }: Props) => {
	return isPreExpand ? (
		// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
		<p data-testid="confluence.project-pages.pre-expand.heading">
			{intl.formatMessage(messages.headingInfo)}
		</p>
	) : null;
};

export default injectIntl(PagesHeading);
